module.exports = __webpack_public_path__ + "static/media/postcard.89e52ecb.jpg";